export { applyBindings } from './applyBindings';
export { getBindingMeta } from './bindingMetaRegistry';
export { createBoundRender } from './createBoundRender';
export {
  MULTI_SELECT_BINDING_META,
  formStateToMultiSelect,
  multiSelectToFormState,
} from './multi-select-binding-meta';
export {
  evaluateShowOn,
  evaluateVisibilityWhen,
  isNodeVisible,
  isNodeVisibleFromRaw,
  parseVisibilityMeta,
  VISIBILITY_BREAKPOINT_MEDIA,
} from './visibility';
export type {
  VisibilityMeta,
  VisibilityWhen,
  VisibilityContext,
  VisibilityBreakpointToken,
} from './visibility';
export {
  BIND_PREFIX,
  ACTION_PREFIX,
  META_PREFIX,
  AUTO_SELECT_FIRST_OPTION_PROP,
  FORM_KEY_PROP,
  DEFAULT_EVENT_PROP_NAMES,
  OPTION_LABEL_FIELD,
  OPTION_VALUE_FIELD,
  RESERVED_BINDING_KEY_PREFIXES,
  isBindingLanguageKey,
} from './constants';
export type {
  BindDeclaration,
  BindTransform,
  ActionDeclaration,
  ActionParamValue,
  ComponentBindingMeta,
} from './types';

/**
 * The predicate the resolver itself applies, exported because consumers derive
 * bindings rather than only authoring them.
 *
 * A derived declaration that fails this is not reported: it stops being a
 * binding and travels on as an ordinary prop, so the control renders as though
 * nothing was bound. A consumer that builds declarations can assert against
 * this instead of restating the rules and drifting from them.
 */
export { isBindDeclaration } from '../binding-resolver/isBindDeclaration';
